import {Debouncer} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Storage} from './storage'

const BOARD_SCROLL_POSITIONS_KEY = 'boardScrollPositions'
const DEBOUNCE_TIMEOUT_MS = 300

interface ScrollPositions {
  [boardId: DataObjectId]: number
}

class BoardScrollStorageService {
  private saveDebouncer = new Debouncer<void>(DEBOUNCE_TIMEOUT_MS)

  private getPositions(): ScrollPositions {
    return (
      Storage.getItemAsJson<ScrollPositions>(BOARD_SCROLL_POSITIONS_KEY) ?? {}
    )
  }

  public getScrollPosition(boardId: DataObjectId | undefined): number {
    if (!boardId) {
      return 0
    }
    const positions = this.getPositions()
    return positions[boardId] ?? 0
  }

  public saveScrollPosition(
    boardId: DataObjectId | undefined,
    scrollLeft: number
  ): void {
    if (!boardId) {
      return
    }

    this.saveDebouncer.runLatest(() => {
      const positions = this.getPositions()
      positions[boardId] = scrollLeft
      Storage.setItemAsJson(BOARD_SCROLL_POSITIONS_KEY, positions)
    })
  }
}

export const BoardScrollStorage = new BoardScrollStorageService()
